const states = {
    filter_details: {
        filters:[],
        loaders:{
            filters_loading: false,
            filters_loaded: false
        }
    },
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/filter_details/states.js